import React from "react";
import styled, { keyframes, css } from "styled-components";
import { ReactComponent as Star } from "../assets/Star.svg";

const STAR_POSITIONS = [
  [454, 131],
  [784, 141],
  [202, 331],
  [384, 151],
  [292, 391],
  [382, 451],
  [644, 571],
  [112, 421],
  [794, 751],
  [1624, 201],
  [1764, 631],
  [1694, 671],
  [1724, 701],
  [694, 821],
  [734, 851],
  [1684, 1031],
  [1790, 2842],
  [1700, 2932],
  [1610, 2872],
  [1480, 2842],
  [1258, 2692],
  [1108, 2512],
  [1168, 2412],
  [1208, 2442],
  [798, 2572],
  [388, 2702],
  [138, 2632],
  [178, 2562],
  [218, 2232],
  [208, 2592],
  [1118, 3122],
  [1448, 3132],
  [1518, 3112],
  [278, 3062],
  [118, 3002],
  [88, 3022],
  [488, 2912],
  [888, 2882],
  [901, 2872],
  [384, 151],
  [1514, 561],
  [1104, 691],
  [422, 421],
];
const STAR_PERCENTAGES = STAR_POSITIONS.map(([x, y]) => [x / 19.2, y]);

interface StarProps {
  index: number;
}

const starFadeIn = keyframes`
      from { opacity: 0; }
      to { opacity: 0.75; }
  `;

const starCircling = keyframes`
      from { transform-origin: 300px; transform: translateX(-300px) rotate(0deg); }
      to { transform-origin: 300px; transform: translateX(-300px) rotate(360deg); }
  `;

const AnimatedStar = styled(Star)<StarProps>`
  position: absolute;
  z-index: 1;

  animation: ${starFadeIn} 1.6s ease-out
      ${(props: StarProps) => props.index * 0.5}s both,
    ${starCircling} ${(props: StarProps) => Math.sin(props.index) * 200 + 600}s
      linear infinite;

  ${(props: StarProps) => {
    const [x, y] = STAR_PERCENTAGES[props.index];
    return css`
      left: ${x}%;
      top: ${y}px;
    `;
  }}
`;

const StarsContainer = styled.div`
  /* these styles make sure stars cause no horizontal scrollbars */
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

const Stars: React.FC = () => (
  <StarsContainer>
    {STAR_PERCENTAGES.map((_, index) => (
      <AnimatedStar key={index} index={index} />
    ))}
  </StarsContainer>
);

export default Stars;
